import { ColumnType } from 'antd/es/table';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getAccessObjectColumns } from '../columns/AccessObjectColumns';

import { AccessExplainerObject, AccessObject, AccessType } from '@sonar-software/sonar-core';

type ColumnDefinition = ColumnType<AccessExplainerObject>;

export function getRowKey(accessObject: AccessExplainerObject) {
	return accessObject.objectId;
}

export const objectNameColumn: ColumnDefinition = {
	dataIndex: 'objectName',
	fixed: 'left',
	key: 'objectName',
	title: COPY_SPECIFIC.OBJECT,
	width: 160
};

export function getColumns(
	dynamicColumns: Record<string, AccessObject>,
	highlightDifferences: boolean,
	additionalColumnIds?: Array<string>,
	onAddPermissionObject?: (label: string, type: AccessType, value: string) => void,
	onRemovePermissionObject?: (accessKey: string) => void
): Array<ColumnDefinition> {
	const columns = getAccessObjectColumns<AccessExplainerObject>('object',
		 dynamicColumns,
		highlightDifferences,
		additionalColumnIds,
		onAddPermissionObject,
		onRemovePermissionObject);

	return [
		objectNameColumn,
		...columns
	];
}
